define('components/course/collections/base',[
    'components/boilerplate/collections/base'
], function (Base) {
    "use strict";

    return Base;
});

